import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SecuritiesPropertyService } from 'src/app/services/securities-property/securities-property.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-liberar-compra-convites-dialog',
  templateUrl: './liberar-compra-convites-dialog.component.html',
  styleUrls: ['./liberar-compra-convites-dialog.component.scss'],
})
export class LiberarCompraConvitesDialogComponent implements OnInit {
  securitiesPropertyId: number | null = null;

  liberarCompraDate: Date | null = null;
  liberarCompraQty: number | null = null;
  today: Date = new Date();

  constructor(
    private config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private securitiesPropertyService: SecuritiesPropertyService,
    private spinner: NgxSpinnerService,
    private messageUtil: MessageUtil
  ) {}

  ngOnInit(): void {
    this.securitiesPropertyId = this.config?.data?.securitiesPropertyId ?? null;
    this.liberarCompraDate = new Date();
    this.liberarCompraQty = null;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.securitiesPropertyId == null) {
      return;
    }
    if (!this.liberarCompraDate) {
      this.messageUtil.generateMessage(
        'warning',
        'Atenção',
        'Informe a data.'
      );
      return;
    }
    if (
      this.liberarCompraQty == null ||
      this.liberarCompraQty === undefined ||
      this.liberarCompraQty < 1
    ) {
      this.messageUtil.generateMessage(
        'warning',
        'Atenção',
        'Informe o número adicional de convites (mínimo 1).'
      );
      return;
    }
    const d = this.liberarCompraDate;
    const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(d.getDate()).padStart(2, '0')}`;

    this.spinner.show();
    this.securitiesPropertyService
      .addInviteToBuyHistoric({
        securitiesPropertyId: this.securitiesPropertyId,
        date: dateStr,
        numberInviteToBuy: this.liberarCompraQty,
      })
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.messageUtil.generateMessage(
            'success',
            'Sucesso',
            'Registro de liberação de compra de convites salvo.'
          );
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.spinner.hide();
          const ex = error?.error?.data?.exception;
          if (ex) {
            this.messageUtil.generateMessage(ex.type, ex.title, ex.message);
          } else {
            const msg =
              typeof error?.error?.message === 'string'
                ? error.error.message
                : 'Não foi possível salvar o registro.';
            this.messageUtil.generateMessage('error', 'Erro', msg);
          }
        },
      });
  }
}
